import Main from "./component/main";
import "./App.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <Main/>
      <ToastContainer />
    </div>
  );
}

export default App;
